import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { NavigationClient } from '@azure/msal-browser';

class CustomNavigationClient extends NavigationClient {
    constructor(navigate) {
        super();
        this.navigate = navigate;
    }
    async navigateInternal(url, options) {
        const relativePath = url.replace(window.location.origin, '');

        if (options.noHistory) {
            this.navigate(relativePath, { replace: true });
        } else {
            this.navigate(relativePath);
        }

        return false;
    }
}

const useCustomNavigationClient = () => {
    const { instance } = useMsal();
    const navigate = useNavigate();

    useEffect(() => {
        const navigationClient = new CustomNavigationClient(navigate);

        instance.setNavigationClient(navigationClient);
    }, [navigate, instance]);
};

export default useCustomNavigationClient;
